import React from 'react';
import { FormBuilder, Button as UdeskButton } from 'udesk-ui';
import LoginRoute from './route';
import { Layout } from './components/Layout';
import VirtualLogin from 'src/components/pages/components/VirtualLogin';
import VerifyModal from 'src/components/pages/components/VerifyModal';

const Button = (props) => {
    return <UdeskButton {...props} htmlType="submit"></UdeskButton>;
};

export default class LoginTemplate extends LoginRoute {
    render() {
        const { state, privates, locales } = this;

        return (
            <Layout
                desc={
                    /* 欢迎回来！请输入您的详细信息 */ locales.pages.login.template
                        .welcomeBackPleaseEnterYourDetails
                }
                isIpForbidden={privates.isIpForbidden}
                onAfterClose={this.actions.onAfterClose}
            >
                <FormBuilder
                    customComponents={{ Button }}
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    layout="vertical"
                    ref={privates.formInstance}
                    onFinish={this.actions.loginV2}
                    fields={[
                        {
                            label: /* 邮箱 */ locales.pages.login.template.mailbox,
                            type: 'Input',
                            name: 'email',
                            props: {
                                size: 'large',
                                placeholder: locales.labels.pleaseEnter,
                            },
                        },
                        {
                            label: /* 密码 */ locales.pages.login.template.password,
                            type: 'Password',
                            name: 'password',
                            validateStatus:
                                state.errorMsg && !privates.verifyModalVisible
                                    ? 'error'
                                    : 'validating',
                            help:
                                state.errorMsg && !privates.verifyModalVisible
                                    ? state.errorMsg
                                    : undefined,
                            props: {
                                size: 'large',
                            },
                        },
                        {
                            type: 'Button',
                            props: {
                                children: /* 登录 */ locales.pages.login.template.signIn,
                                block: true,
                                size: 'large',
                                type: 'primary',
                                loading: state.loading,
                                style: {
                                    marginTop: 24,
                                },
                            },
                        },
                    ]}
                    footerRender={false}
                />

                <VirtualLogin
                    visible={privates.virtualLoginModal}
                    relationCompanyList={privates.relationCompanyList}
                    onCancel={() => this.actions.onVirtualLoginModalClose()}
                />

                <VerifyModal
                    visible={privates.verifyModalVisible}
                    onCancel={() => this.actions.onVerifyModalClose()}
                    onLogin={(code) => this.actions.onVerifyLogin(code)}
                    langCode={privates.langCode}
                    validateStatus={state.errorMsg ? 'error' : undefined}
                    help={state.errorMsg || undefined}
                    verifyParams={{
                        mobile: privates.loginParams.mobile,
                        email: privates.loginParams.email,
                        password: privates.loginParams.password,
                    }}
                    loading={state.loading}
                />
            </Layout>
        );
    }
}
